/**
 * Per-round question/choice order.
 * Missing flags default to true (shuffle) so existing competitions stay random.
 */

export function shuffleQuestionsEnabled(round) {
  return round?.shuffleQuestions !== false;
}

export function shuffleChoicesEnabled(round) {
  return round?.shuffleChoices !== false;
}

function createdAtMs(ch) {
  const v = ch?.createdAt;
  if (!v) return 0;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (v instanceof Date) return v.getTime();
  if (typeof v.seconds === 'number') return v.seconds * 1000;
  if (typeof v._seconds === 'number') return v._seconds * 1000;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

export function sortChallengesByUploadOrder(challenges) {
  return [...challenges].sort((a, b) => {
    const na = Number(a.number);
    const nb = Number(b.number);
    const aHas = Number.isFinite(na);
    const bHas = Number.isFinite(nb);
    if (aHas && bHas && na !== nb) return na - nb;
    if (aHas && !bHas) return -1;
    if (!aHas && bHas) return 1;
    const byTime = createdAtMs(a) - createdAtMs(b);
    if (byTime !== 0) return byTime;
    return String(a.id || '').localeCompare(String(b.id || ''));
  });
}

export function pickAssignedChallengeIds(challenges, count, shuffleQuestions) {
  if (!Array.isArray(challenges) || challenges.length === 0 || count <= 0) {
    return [];
  }
  const n = Math.min(count, challenges.length);
  if (shuffleQuestions) {
    const shuffled = [...challenges].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, n).map((ch) => ch.id);
  }
  return sortChallengesByUploadOrder(challenges)
    .slice(0, n)
    .map((ch) => ch.id);
}

export function identityChoiceOrder(n) {
  const len = Number(n) || 0;
  return Array.from({ length: len }, (_, i) => i);
}

export function nextChallengeNumber(challenges, category) {
  const sameCat = (challenges || []).filter((c) => c.category === category);
  return sameCat.reduce((max, c) => {
    const n = Number(c.number);
    return Number.isFinite(n) ? Math.max(max, n) : max;
  }, 0) + 1;
}
